import { areaService } from '../services/areaService';
import { authService } from '../services/authService';
import { chartService } from '../services/chartService';
import { chromatogramService } from '../services/chromatogramService';
import { commentService } from '../services/commentService';
import { companyService } from '../services/companyService';
import { depositService } from '../services/depositService';
import { fieldService } from '../services/fieldService';
import { horizonService } from '../services/horizonService';
import { interpolationMapService } from '../services/interpolationMapService';
import { layerService } from '../services/layerService';
import { lookupsService } from '../services/lookupsService';
import { minireportService } from '../services/miniportService';
import { notificationService } from '../services/notoficationService';
import { projectService } from '../services/projectService';
import { reportService } from '../services/reportService';
import { researchObjectiveService } from '../services/researchObjectiveServices';
import { reservoirService } from '../services/reservoirService';
import { resultTableService } from '../services/resultTableService';
import { studiedPhaseService } from '../services/studiedPhaseService';
import { userService } from '../services/userService';
import { wellService } from '../services/wellService';
import authSlice from './authSlice';

const reducers = {
  auth: authSlice,
  

  /** Auth services */
  [authService.reducerPath]: authService.reducer,
  [chartService.reducerPath]: chartService.reducer,
  [userService.reducerPath]: userService.reducer,
  [projectService.reducerPath]: projectService.reducer,
  [companyService.reducerPath]: companyService.reducer,
  [areaService.reducerPath]: areaService.reducer,
  [depositService.reducerPath]: depositService.reducer,
  [fieldService.reducerPath]: fieldService.reducer,
  [horizonService.reducerPath]: horizonService.reducer,
  [layerService.reducerPath]: layerService.reducer,
  [reservoirService.reducerPath]: reservoirService.reducer,
  [wellService.reducerPath]: wellService.reducer,
  [chromatogramService.reducerPath]: chromatogramService.reducer,
  [reportService.reducerPath]: reportService.reducer,
  [minireportService.reducerPath]: minireportService.reducer,
  [researchObjectiveService.reducerPath]: researchObjectiveService.reducer,
  [studiedPhaseService.reducerPath]: studiedPhaseService.reducer,
  [interpolationMapService.reducerPath]: interpolationMapService.reducer,
  [resultTableService.reducerPath]: resultTableService.reducer,
  [commentService.reducerPath]: commentService.reducer,
  [notificationService.reducerPath]: notificationService.reducer,
  [lookupsService.reducerPath]: lookupsService.reducer,

  
};

export default reducers;
